import { TEXT_QUESTION_TYPES } from 'constants/formConstants';

import { detectLanguage } from './answerTranslationService';
import { QuestionDataFactory } from './questionDataFactory';

export const createFormDataProcessor = endpoint => {
  return async (formData, currentQuestion, accumulatedEnhancedValues = {}) => {
    const mappedData = { ...accumulatedEnhancedValues };

    for (const [key, value] of Object.entries(formData)) {
      const sanitizedValue = QuestionDataFactory.sanitizeValue(value);

      const shouldDetect =
        sanitizedValue &&
        typeof sanitizedValue === 'string' &&
        sanitizedValue.trim().length > 0 &&
        currentQuestion.id.toString() === key &&
        TEXT_QUESTION_TYPES.includes(currentQuestion.type);

      if (shouldDetect) {
        const result = await detectLanguage(sanitizedValue, endpoint);
        mappedData[key] = QuestionDataFactory.create(sanitizedValue, {
          languageDetection: true,
          languageCode: result?.languageCode ?? null,
          score: result?.score ?? null,
        });
      } else {
        if (!mappedData[key] || !QuestionDataFactory.isProcessed(mappedData[key])) {
          mappedData[key] = QuestionDataFactory.create(sanitizedValue);
        } else {
          mappedData[key] = { ...mappedData[key], value: sanitizedValue };
        }
      }
    }

    return mappedData;
  };
};
